import { router } from 'expo-router';

import type { Command } from './types';

export const newInspectionCommand: Command = {
	id: 'new-inspection',
	title: 'New Inspection',
	description: 'Create a new inspection report',
	icon: 'camera-outline',
	category: 'create',
	keywords: ['inspection', 'report', 'photo', 'camera'],
	action: (closeSearch) => {
		router.push('/inspections/new');
		closeSearch?.();
	},
};
